import { render } from "./ForgeViewer.vue?vue&type=template&id=fa82421e&scoped=true"
import script from "./ForgeViewer.vue?vue&type=script&lang=js"
export * from "./ForgeViewer.vue?vue&type=script&lang=js"

import "./ForgeViewer.vue?vue&type=style&index=0&id=fa82421e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa82421e"]])

export default __exports__